import { countries as api_countries } from "@/api";

// Types
export const GET_COUNTRIES_BEGIN = "GET_COUNTRIES_BEGIN";
export const GET_COUNTRIES_ERROR = "GET_COUNTRIES_ERROR";
export const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";

// models
class Country {
  constructor(data) {
    this.code = data["code"];
    this.name = data["name"];
  }
}

const models = {
  Country
};

// initial state
// shape: [{ code, name }]
const state = () => ({
  error: false,
  loading: false,
  countriesOrdered: [],
  countriesByCode: {},
})

// getters
const getters = {
  getCountries: state => state.countriesOrdered,
  countriesLoaded: state => !!state.countriesOrdered.length,
  getCountryByCode: (state) => (code) => state.countriesByCode[code],
}

// actions
const getCountries = async ({ commit }, auth) => {
  commit(GET_COUNTRIES_BEGIN);
  try {
    const response = await api_countries.getCountries(auth)
    const { data } = response;
    const countries = data.map((elem) => (new Country(elem)));
    commit(GET_COUNTRIES_SUCCESS, { countries });
    return response;
  } catch (error) {
    // TODO: Properly handle call errors
    commit(GET_COUNTRIES_ERROR);
    throw error;
  }
};

const actions = {
  getCountries
}

// mutations
const mutations = {
  [GET_COUNTRIES_BEGIN](state) {
    state.loading = true;
    state.error = false;
    state.countriesOrdered = [];
    state.countriesByCode = {};
  },
  [GET_COUNTRIES_SUCCESS](state, { countries }) {
    state.error = false;
    state.loading = false;
    let _byCode = {};
    let _ordered = [];
    countries.map(country => {
      _byCode = { ..._byCode, [country.code]: country };
      _ordered = [..._ordered, country.code];
    });
    state.countriesOrdered = [..._ordered];
    state.countriesByCode = { ..._byCode };
  },
  [GET_COUNTRIES_ERROR](state) {
    state.error = true;
    state.loading = false;
    state.countriesOrdered = [];
    state.countriesByCode = {};
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  models
}